import React from "react";
import { Modal, Col, Row } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./ConfirmModal.css";

export default function ConfirmModal(props) {
  const { visible, setVisible, msg, runFunc, loading } = props;

  return (
    <Modal
      closable={false}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      // width="30vw"
      centered
      className="confirm-modal"
    >
      <Row>
        <Col span={24}>
          <div className="confirm-modal-card">
            <p className="confirm-modal-message">{msg}</p>
            <div className="confirm-modal-buttons-container">
              <div className="confirm-modal-accept-button-container">
                {loading ? (
                  <div className="confirm-modal-loading">
                    <Loading3QuartersOutlined spin />
                  </div>
                ) : (
                  <div onClick={runFunc} className="confirm-modal-accept-button">
                    <span className="confirm-modal-accept-button-font">Yes</span>
                  </div>
                )}
              </div>
              <div
                className="confirm-modal-cancel-button"
                onClick={() => {
                  setVisible(false);
                }}
              >
                <span className="confirm-modal-accept-button-font">No</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Modal>
  );
}
